export async function blobUrlToFile(blobUrl, fileName) {
  // Fetch the blob data from the blob URL
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  // Create a File object from the blob
  const file = new File([blob], fileName, {
    type: blob.type,
    lastModified: Date.now(),
  });

  return file;
}
